<template>
  <v-card rounded raised clas="ma-0" class="card-border">
    <v-card-title class="d-flex justify-between px-0 py-0">
      <v-toolbar color="grey lighten-3" elevation="0">
        <v-toolbar-title class="activity_header">
          <v-layout column>
            <v-flex>
              <h4 style="text-overflow: ellipsis; overflow: hidden;">
                {{ title }}
              </h4>
            </v-flex>
          </v-layout>
        </v-toolbar-title>
        <v-spacer />
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon @click="closeCard" v-on="on">
              <v-icon>
                close
              </v-icon>
            </v-btn>
          </template>
          <span>Close</span>
        </v-tooltip>
      </v-toolbar>
    </v-card-title>
    <v-card-text>
      <div class="d-flex flex-column justify-space-between">
        <div class="card-info-prop d-flex align-center">
          <span class="font-weight-bold primary--text">Value:</span>
          <span>{{ value }}</span>
          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-btn
                icon
                x-small
                class="info-value"
                @click.stop="openInfo"
                v-on="on"
              >
                <v-icon>
                  info
                </v-icon>
              </v-btn>
            </template>
            <span>More information</span>
          </v-tooltip>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { getPseudoIdentifyOverlay } from "@/services/map";
export default {
  name: "PseudoIdentifyPopup",
  methods: {
    closeCard() {
      getPseudoIdentifyOverlay().setPosition(undefined);
    },
    openInfo() {
      window.open(
        "https://help.coloradoforestatlas.org/public/map-theme-descriptions"
      );
    },
  },
  computed: {
    title() {
      return this.$store.state.selectedmaptheme.name;
    },
    value() {
      return this.$store.state.themeIdentifyValue;
    },
  },
};
</script>

<style lang="stylus" scoped>
.card-info-prop {
  margin: 2px 0;
}

.card-border {
  border: 1px solid black;
}

.info-value {
  margin-left 4px;
}
</style>
